//deprecated, to refactor to NGRX Store
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShareDataService {
  //mainly used for validation messages and AO Summary
  consErrorMsgs: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  //used for AO workflow data
  shareData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  //used to disable or enable buttons in AO workflow
  validateBtns: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  //use for ao-dialog
  shareString: BehaviorSubject<any> = new BehaviorSubject(null);
  //used to check user's choice in attachment dialog, and for loader in basic info (general.component.ts)
  shareBoolean: BehaviorSubject<any> = new BehaviorSubject(null);
  //used for add item edit mode
  shareItemData: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  shareOfficerData: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  constructor() {}

  storeConsErrorMsgs(passedData: any) {
    this.consErrorMsgs.next(passedData);
  }

  storeSharedData(passedData: any) {
    this.shareData.next(passedData);
  }

  storeValidateBtns(passedData: any) {
    this.validateBtns.next(passedData);
  }

  storeItemData(passedData: any) {
    this.shareItemData.next(passedData);
  }


  storeSharedString(passedData: any) {
    this.shareString.next(passedData);
  }

  storeSharedBoolean(passedData: any) {
    this.shareBoolean.next(passedData);
  }

  storeOfficerData(data: any) {
    this.shareOfficerData.next(data);
  }

  // here instead of retrieve like this you can directly subscribe the property in your components
  retrieveConsErrorMsgs() {
    return this.consErrorMsgs;
  }

  retrieveShareData() {
    return this.shareData;
  }

  retrieveValidateBtns() {
    return this.validateBtns;
  }

  retrieveItemData() {
    return this.shareItemData;
  }

  retrieveShareString() {
    return this.shareString;
  }

  retrieveShareBoolean() {
    return this.shareBoolean;
  }
}
